import Contenedor from "../../../components/generalStructure/Contenedor/Contenedor";

const ContenedorInfoImportante = () => {
    return (
        <Contenedor
            titulo="Información importante"
            className="my-3 bg-info"
            color="#FFF"
        >
            <div className="text-white">
                <li>Se podrán solicitar turnos de ingreso de Miércoles a Domingo para la semana siguiente.</li>
                <li>Los INVITADOS solo pueden ingresar en presencia del TITULAR (con DNI)</li>
                {/* <li>El Ingreso es exclusivamente para Afiliados a SMATA.</li> */}
            </div>
        </Contenedor>
    )
};

export default ContenedorInfoImportante;